import { FilterType } from './types'

export const FILTER_QUERIES: Record<FilterType, string> = {
  ACTIVE: '&status[]=active',
  INVALIDATED: '&status[]=canceled',
  EXPIRED: '&status[]=expired',
  STANDALONE: '&code_type[]=global',
  BULKCODES: '&code_type[]=unique',
}

export const filters = [
  {
    id: 1,
    name: 'status',
    label: 'status',
    options: [
      { value: 'ACTIVE', label: 'vouchers.active' },
      { value: 'INVALIDATED', label: 'vouchers.invalidated' },
      { value: 'EXPIRED', label: 'vouchers.expired' },
    ],
  },
  {
    id: 2,
    name: 'vouchers.text',
    label: 'vouchers.text',
    options: [
      { value: 'STANDALONE', label: 'vouchers.standalone' },
      { value: 'BULKCODES', label: 'vouchers.bulkCodes' },
    ],
  },
]
